﻿import React from "react";
import { useActivitiesData, useActivityItem } from "./ActivitiesDataContext";

const defaultColor = "#FEFEFE";

const ActivitySparkline = {
    fields: {
        height: { type: "text" as const },
        color: { type: "text" as const },
    },
    defaultProps: {
        height: "50",
        color: defaultColor,
    },
    inline: true,
    render: (props: any) => {
        const { height, color, puck } = props as any;
        const h = Math.max(10, parseInt(height || "50", 10) || 50);
        const { helpers } = useActivitiesData();
        const { item } = useActivityItem();
        const id = `spark-${item.activityGuid}`;
        const d = helpers.buildSparkPath(item.sparkline, 200, h);

        const actualColor = color || defaultColor;

        return (
            <div ref={puck.dragRef} className="mt-4">
                <div style={{ height: `${h}px`, width: "100%" }}>
                    <svg
                        viewBox={`0 0 200 ${h}`}
                        preserveAspectRatio="none"
                        className="w-full h-full"
                    >
                        <defs>
                            <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor={actualColor} stopOpacity="0.9" />
                                <stop offset="100%" stopColor={actualColor} stopOpacity="0.2" />
                            </linearGradient>
                        </defs>
                        <path d={d} fill="none" stroke={`url(#${id})`} strokeWidth="2" />
                    </svg>
                </div>
            </div>
        );
    },
};

export default ActivitySparkline;


